<template>
    <div class="progress-spinner" :style="Style2" v-if="isLoading">
        <div class="text-center">
            <ProgressSpinner :style="Style" strokeWidth="2" animationDuration=".9s"/>
            <div class="loaderLabel" v-if="label">{{label}}</div>
        </div>
    </div>
</template>

<script>
    import ProgressSpinner from 'primevue/progressspinner';
    export default {
        name: "Loader",
        props: {
            isLoading: Boolean,
            size: {
                type: Number,
                default: 100
            },
            position:{
                type: String,
                default: "absolute"
            },
            label:{
                type: String,
                default: null
            }
        },
        computed: {
            Style() {
                return `width:${this.size}px; height:${this.size}px`;
            },
            Style2() {
                return `min-height:60px; position:${this.position}`;
            }
        },
        components: { ProgressSpinner }
    }
</script>

<style scoped>
    .progress-spinner{ z-index: 200; top:0; left:0; right: 0; position: absolute; width: 100%; height: 100%; background: rgba(210,210,210,0.4); display: flex; align-items: center; justify-content: center; }
    .progress-spinner.top { align-items: baseline; padding-top: 50px; }
    .progress-spinner > .loaderLabel{

    }

</style>